<template lang="pug">

  .ParagraphList
    template(v-for="(p, index) in items")
      component(:is="getComponent(p)", :key="p.id", :item="p")

</template>

<script>

import scrollUpdate from '@/mixins/scrollUpdate'
import ParagraphQuizz from '@/components/paragraphs/ParagraphQuizz'
import Paragraph from '@/components/paragraphs/Paragraph'
import ParagraphMap from '@/components/paragraphs/ParagraphMap'
import ParagraphPortrait from '@/components/paragraphs/ParagraphPortrait'
import ParagraphWysisyg from '@/components/paragraphs/ParagraphWysisyg'
import ParagraphVisuals from '@/components/paragraphs/ParagraphVisuals'
import ParagraphSound from '@/components/paragraphs/ParagraphSound'
import ParagraphFile from '@/components/paragraphs/ParagraphFile'
import ParagraphKeyFigures from '@/components/paragraphs/ParagraphKeyFigures'
import ParagraphSamples from '@/components/paragraphs/ParagraphSamples'
import ParagraphDrawers from '@/components/paragraphs/ParagraphDrawers'
import ParagraphExergue from '@/components/paragraphs/ParagraphExergue'
import ParagraphDYKT from '@/components/paragraphs/ParagraphDYKT'
import ParagraphImageText from '@/components/paragraphs/ParagraphImageText'

const mapParagraphTypes = new Map([
  ['paragraph--quizz', ParagraphQuizz],
  ['paragraph--map', ParagraphMap],
  ['paragraph--portrait', ParagraphPortrait],
  ['paragraph--wysisyg', ParagraphWysisyg],
  ['paragraph--visuals', ParagraphVisuals],
  ['paragraph--sound', ParagraphSound],
  ['paragraph--file', ParagraphFile],
  ['paragraph--key_figures', ParagraphKeyFigures],
  ['paragraph--drawers', ParagraphDrawers],
  ['paragraph--samples', ParagraphSamples],
  ['paragraph--exergue', ParagraphExergue],
  ['paragraph--did_you_know_that', ParagraphDYKT],
  ['paragraph--image_text', ParagraphImageText]
])

export default {
  props: ['items'],
  mixins: [scrollUpdate],
  components: { Paragraph, ParagraphQuizz, ParagraphPortrait, ParagraphWysisyg },
  methods: {
    getComponent (p) {
      let c = mapParagraphTypes.get(p.type)
      return c || Paragraph
    },
    onEnter () {
      document.body.querySelector('.HeaderLogo').classList.add('HeaderLogo-dark')
    },
    onExit () {
      document.body.querySelector('.HeaderLogo').classList.remove('HeaderLogo-dark')
    }
  },
  mounted () {
    let p = this.$el.querySelectorAll('.Paragraph, .ParagraphWysisyg')
    for (let i = 0; i < p.length; i++) {
      this.$parallax.set(p[i], { y: 0 }, { y: 60 }, { y: 0 })
    }

    // let img = this.$el.querySelectorAll('img')
    // for (let i = 0; i < img.length; i++) {
    //   this.$parallax.set(img[i], { y: 0 }, { y: 60 }, { y: -60 })
    // }
  },
  beforeDestroy () {
    // let p = this.$el.querySelectorAll('.Paragraph, .ParagraphWysisyg')
    // for (let i = 0; i < p.length; i++) {
    //   this.$parallax.remove(p[i])
    // }
  }
}

</script>

<style lang="stylus">

.ParagraphList
  &::before,
  &::after // hack - permet au premier élément enfant que son margin soit considéré comme un padding
    display: block
    content ''
    height: 1px
    padding: 0

</style>
